module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_8_1.338403ab.jpg";